import {
  OP_SEARCH_ITEMS,
  NE_SEARCH_ITEMS,
  ES_SEARCH_ITEMS,
  TP_SEARCH_ITEMS,
} from '@doda/common/src/constants/searchItems';
import { EMPLOYMENT_OTHER_ITEM } from '@doda/common/src/constants/screenStructure/searchConditionItems';

export const SEARCH_EMPLOYMENT_OPTIONS = {
  title: '雇用形態',
  list: [
    OP_SEARCH_ITEMS.regularEmployee,
    OP_SEARCH_ITEMS.contractEmployee,
    EMPLOYMENT_OTHER_ITEM,
  ],
} as const;

export const SEARCH_PICKUP_CONDITION_OPTIONS = {
  title: 'こだわり条件ピックアップ',
  list: [
    OP_SEARCH_ITEMS.newArrival,
    OP_SEARCH_ITEMS.deadline,
    OP_SEARCH_ITEMS.fiveDayWorkweekSystem,
    OP_SEARCH_ITEMS.MoreThan120DaysOffAYear,
    OP_SEARCH_ITEMS.inexperiencedOccupationWelcome,
    OP_SEARCH_ITEMS.IndustryInexperiencedWelcome,
    OP_SEARCH_ITEMS.noAcademicBackgroundRequired,
    OP_SEARCH_ITEMS.noTransfer,
  ],
} as const;

export const SEARCH_DETAIL_CONDITION_OPTIONS = [
  {
    title: '休日・働き方',
    list: [
      OP_SEARCH_ITEMS.fiveDayWorkweekSystem,
      OP_SEARCH_ITEMS.fiveDayWorkweekSystem,
      OP_SEARCH_ITEMS.MoreThan120DaysOffAYear,
      OP_SEARCH_ITEMS.holiday,
      OP_SEARCH_ITEMS.consecutiveVacations,
      OP_SEARCH_ITEMS.noOvertime,
      OP_SEARCH_ITEMS.littleOvertime,
      OP_SEARCH_ITEMS.flexibleWork,
      OP_SEARCH_ITEMS.maternityAndChildcareLeave,
    ],
  },
  {
    title: '募集・採用情報',
    list: [
      OP_SEARCH_ITEMS.inexperiencedOccupationWelcome,
      OP_SEARCH_ITEMS.IndustryInexperiencedWelcome,
      OP_SEARCH_ITEMS.noTransfer,
      OP_SEARCH_ITEMS.noAcademicBackgroundRequired,
      OP_SEARCH_ITEMS.secondTimeGraduate,
      OP_SEARCH_ITEMS.expert,
      OP_SEARCH_ITEMS.urgentRecruit,
      OP_SEARCH_ITEMS.employsManyPeople,
      OP_SEARCH_ITEMS.noChangeInJobTitle,
    ],
  },
  {
    title: '会社・職場の環境',
    list: [
      OP_SEARCH_ITEMS.listedCompany,
      OP_SEARCH_ITEMS.foreignCompany,
      OP_SEARCH_ITEMS.fewerRetirees,
      OP_SEARCH_ITEMS.femaleThriving,
      OP_SEARCH_ITEMS.commutingByCar,
      OP_SEARCH_ITEMS.freeDressCode,
    ],
  },
  {
    title: '待遇・福利厚生',
    list: [
      OP_SEARCH_ITEMS.retirementBenefitPlan,
      OP_SEARCH_ITEMS.companyHousingAndEentSubsidySystem,
      OP_SEARCH_ITEMS.childcareAndChildcareSupportSystem,
      OP_SEARCH_ITEMS.qualificationAcquisitionSupportSystem,
      OP_SEARCH_ITEMS.fullTrainingSystem,
      OP_SEARCH_ITEMS.salaryOf250kYenMore,
      OP_SEARCH_ITEMS.salaryOf350kYenMore,
      OP_SEARCH_ITEMS.UIturnSupport,
    ],
  },
  {
    title: '語学',
    list: [OP_SEARCH_ITEMS.english, OP_SEARCH_ITEMS.chinese],
  },
  {
    title: '仕事内容',
    list: [OP_SEARCH_ITEMS.overseasBusinessTrip, OP_SEARCH_ITEMS.manager],
  },
  {
    title: '社員の平均年齢',
    list: [
      OP_SEARCH_ITEMS.twenties,
      OP_SEARCH_ITEMS.thirties,
      OP_SEARCH_ITEMS.forties,
      OP_SEARCH_ITEMS.overFifties,
    ],
  },
  {
    title: '従業員数',
    list: NE_SEARCH_ITEMS.map((item) => ({
      id: item.id,
      name: item.name,
    })),
  },
  {
    title: '設立',
    list: ES_SEARCH_ITEMS.map((item) => ({
      id: item.id,
      name: item.name,
    })),
  },
  {
    title: '応募方法',
    list: [TP_SEARCH_ITEMS.directApplication, TP_SEARCH_ITEMS.agentServices],
  },
] as const;

export const INCOME_VALUE_LIST = [
  {
    id: '20',
    value: '1',
  },
  {
    id: '25',
    value: '2',
  },
  {
    id: '30',
    value: '3',
  },
  {
    id: '35',
    value: '4',
  },
  {
    id: '40',
    value: '5',
  },
  {
    id: '45',
    value: '6',
  },
  {
    id: '50',
    value: '7',
  },
  {
    id: '55',
    value: '8',
  },
  {
    id: '60',
    value: '9',
  },
  {
    id: '65',
    value: '10',
  },
  {
    id: '70',
    value: '11',
  },
  {
    id: '80',
    value: '12',
  },
  {
    id: '90',
    value: '13',
  },
  {
    id: '100',
    value: '14',
  },
] as const;

export const SAVED_CONDITION_LIMIT = 60;

/**
 * 休日・働き方のコード値とクエリ
 */
export const HOLIDAY_AND_WAY_OF_WORKING_CODE_AND_QUERY = {
  FIVE_DAY_WORK_WEEK_SYSTEM: {
    code: '1',
    query: '69',
  },
  MORE_THAN_120_DAYS_OFF_A_YEAR: {
    code: '2',
    query: '5',
  },
  HOLIDAY: {
    code: '3',
    query: '72',
  },
  CONSECUTIVE_VACATIONS: {
    code: '4',
    query: '73',
  },
  NO_OVERTIME: {
    code: '5',
    query: '74',
  },
  LITTLE_OVER_TIME: {
    code: '6',
    query: '60',
  },
  FLEXIBLE_WORK: {
    code: '7',
    query: '6',
  },
  MATERNITY_AND_CHILDCARE_LEAVE: {
    code: '8',
    query: '75',
  },
} as const;

/**
 * 募集・採用情報のコード値とクエリ
 */
export const REQUIREMENT_CODE_AND_QUERY = {
  INEXPERIENCED_OCCUPATION_WELCOME: {
    code: '1',
    query: '70',
  },
  INDUSTRY_INEXPERIENCED_WELCOME: {
    code: '2',
    query: '71',
  },
  NO_ACADEMIC_BACKGROUND_REQUIRED: {
    code: '3',
    query: '24',
  },
  NO_TRANSFER: {
    code: '4',
    query: '27',
  },
  SECOND_TIME_GRADUATE: {
    code: '5',
    query: '3',
  },
  EXPERT: {
    code: '6',
    query: '67',
  },
  URGENT_RECRUIT: {
    code: '7',
    query: '76',
  },
  EMPLOYS_MANY_PEOPLE: {
    code: '8',
    query: '48',
  },
  NO_CHANGE_IN_JOB_TITLE: {
    code: '9',
    query: '86',
  },
} as const;

/**
 * 会社・職場の環境のコード値とクエリ
 */
export const WORKING_PLACE_ENVIRONMENT_CODE_AND_QUERY = {
  LISTED_COMPANY: {
    code: '1',
    query: '47',
  },
  FOREIGN_COMPANY: {
    code: '2',
    query: '4',
  },
  FEWER_RETIREES: {
    code: '3',
    query: '77',
  },
  FEMALE_THRIVING: {
    code: '4',
    query: '33',
  },
  COMMUTING_BY_CAR: {
    code: '5',
    query: '55',
  },
  FREE_DRESS_CODE: {
    code: '6',
    query: '32',
  },
} as const;

/**
 * 待遇・福利厚生のコード値とクエリ
 */
export const WELFARE_BENEFITS_CODE_AND_QUERY = {
  RETIREMENT_BENEFIT_PLAN: {
    code: '1',
    query: '56',
  },
  COMPANY_HOUSING_AND_ENT_SUBSIDY_SYSTEM: {
    code: '2',
    query: '44',
  },
  CHILDCARE_AND_CHILDCARE_SUPPORT_SYSTEM: {
    code: '3',
    query: '65',
  },
  QUALIFICATION_ACQUISITION_SUPPORT_SYSTEM: {
    code: '4',
    query: '45',
  },
  FULL_TRAINING_SYSTEM: {
    code: '5',
    query: '46',
  },
  SALARY_OF_250K_YEN_MORE: {
    code: '6',
    query: '79',
  },
  SALARY_OF_350K_YEN_MORE: {
    code: '7',
    query: '80',
  },
  U_ITURN_SUPPORT: {
    code: '8',
    query: '81',
  },
} as const;

/**
 * 語学のコード値とクエリ
 */
export const LANGUAGE_SKILL_CODE_AND_QUERY = {
  ENGLISH: {
    code: '1',
    query: '21',
  },
  CHINESE: {
    code: '2',
    query: '49',
  },
} as const;

/**
 * 仕事内容のクエリ
 */
export const POSITION_CODE_AND_QUERY = {
  OVERSEAS_BUSINESS_TRIP: {
    code: '1',
    query: '78',
  },
  MANAGER: {
    code: '2',
    query: '8',
  },
} as const;

/**
 * 社員の平均年齢のクエリ
 */
export const EMPLOYEE_AVERAGE_AGE_CODE_AND_QUERY = {
  TWENTY: {
    code: '1',
    query: '82',
  },
  THIRTY: {
    code: '2',
    query: '83',
  },
  FORTY: {
    code: '3',
    query: '84',
  },
  FIFTY: {
    code: '4',
    query: '85',
  },
} as const;

/**
 * 応募方法のクエリ
 */
export const JOB_OFFER_KIND_CODE_AND_QUERY = {
  AGENT_SERVICES: {
    code: '1',
    query: '0',
  },
  DIRECT_APPLICATION: {
    code: '2',
    query: '2',
  },
  DEFAULT: {
    code: null,
    query: '1',
  },
} as const;

/**
 * サジェスト実行時のキーワードの最小値
 */
export const MIN_INPUT_LENGTH = 3;

/**
 * キーワードカテゴリーデフォルト値
 */
export const DEFAULT_SEARCH_CATEGORY = '1';
